import { render, staticRenderFns } from "./UpdateVersion.vue?vue&type=template&id=0e4d5bd0&scoped=true"
import script from "./UpdateVersion.vue?vue&type=script&lang=js"
export * from "./UpdateVersion.vue?vue&type=script&lang=js"
import style0 from "./UpdateVersion.vue?vue&type=style&index=0&id=0e4d5bd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4d5bd0",
  null
  
)

export default component.exports